// extracted by mini-css-extract-plugin
module.exports = {"history_step":"styles_history_step__1vKpl","history_step__title":"styles_history_step__title__1gLfU","history_step__steps":"styles_history_step__steps__2ixIy"};